import { styled } from '@mui/material/styles'
import { Grid, Typography } from '@mui/material'

export const CheckboxWrapper = styled(Grid)(({ theme }) => `
    max-height: 200px;
    overflow:auto;
    // border: 1px solid #E4E7EC;
    border: 1px ${theme.components.GridList.styleOverrides.borderColor} solid;
    // background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.12);
    display:flex;
    flex-direction: column;

    & label { margin: 0; }
    & label span { padding-top: 2px; padding-bottom: 2px; }
`)

export const Title = styled(Typography)(({ theme }) => `
    display: flex;
    align-items: center;
    font-size:10px;
    color: ${theme.components.MuiParagraph.styleOverrides.lightColor};
    & span { font-size:10px; padding-left:5px;}
`)
